// extracted by mini-css-extract-plugin
export var productImage = "_x0-0";